import { toast } from "react-toastify";

const optionsToast = {
	position: "top-center",
	autoClose: 2000,
	hideProgressBar: false,
	closeOnClick: true,
	pauseOnHover: true,
	draggable: true,
	progress: undefined,
};

const optionsToastError = {
	position: "top-center",
	autoClose: 4000,
	hideProgressBar: false,
	closeOnClick: true,
	pauseOnHover: true,
	draggable: true,
	progress: undefined,
};

const handleMessageWarning = (message) => {
	toast.warning(message, optionsToastError);
};

const handleMessageError = (message) => {
	toast.error(message, optionsToastError);
};

const handleMessageInfo = (message) => {
	toast.success(message, optionsToast);
};

const handleMessageSuccess = (message) => {
	toast.success(message, optionsToast);
};

export { handleMessageWarning, handleMessageError, handleMessageSuccess, handleMessageInfo };

const Notification = {
	showToast: ({ message, type }) => {
		if (type === "success") {
			toast.success(message, optionsToast);
		} else if (type === "error") {
			toast.error(message, optionsToastError);
		} else if (type === "info") {
			toast.info(message, optionsToastError);
		} else if (type === "warning") {
			toast.warning(message, optionsToastError);
		} else {
			toast(message);
		}
	},
};

export default Notification;
